import { render, staticRenderFns } from "./drawerPurchase.vue?vue&type=template&id=1f05d59b&"
import script from "./drawerPurchase.vue?vue&type=script&lang=js&"
export * from "./drawerPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports